"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.soapMessagesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const AuthoredEvidence = __importStar(require("../../../../composite/evidence/authored-evidence/authored-evidence"));
const evidence_1 = require("../../../../composite/evidence/evidence");
const messages_columns_1 = require("./messages-columns");
const messages_fields_1 = require("./messages-fields");
function soapMessagesFactory({ exportTag, url, }) {
    return function SoapMessages() {
        const intl = (0, react_intl_1.useIntl)();
        const evidence = AuthoredEvidence.useAuthoredEvidence({
            version: 4,
            identifier: 'SOAP_MESSAGES2',
            apiProps: {
                url,
            },
            tableProps: {
                reportTag: exportTag,
                columns: (0, messages_columns_1.useColumns)(),
                tableName: intl.formatMessage({
                    id: 'EAS_SOAP_LOGGER_MESSAGES_TABLE_TITLE',
                    defaultMessage: 'SOAP komunikace',
                }),
            },
            detailProps: {
                FieldsComponent: messages_fields_1.MessagesFields,
                toolbarProps: {
                    title: intl.formatMessage({
                        id: 'EAS_SOAP_LOGGER_MESSAGES_DETAIL_TITLE',
                        defaultMessage: 'SOAP komunikace',
                    }),
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, { ...evidence });
    };
}
exports.soapMessagesFactory = soapMessagesFactory;
soapMessagesFactory.useColumns = messages_columns_1.useColumns;
soapMessagesFactory.Fields = messages_fields_1.MessagesFields;
//# sourceMappingURL=messages.js.map